import type {
  Appointment,
  AppointmentServiceConfig,
  AppointmentUpdate,
} from "@/types/appointments/api-types/appointment-types";

export function toAppointmentUpdateFromLineMove(
  appointment: Appointment,
  lineId: number,
  patch: {
    staff_id: number;
    start_time?: string;
    duration_minutes?: number;
    price?: number;
  }
): AppointmentUpdate {
  return {
    services: appointment.services.map((line): AppointmentServiceConfig => ({
      service_id: line.service_id,
      staff_id: line.id === lineId ? patch.staff_id : line.staff_id,
      start_time:
        line.id === lineId && patch.start_time !== undefined
          ? patch.start_time
          : line.start_time,
      duration_minutes:
        line.id === lineId && patch.duration_minutes !== undefined
          ? patch.duration_minutes
          : line.duration_minutes,
      price:
        line.id === lineId && patch.price !== undefined
          ? patch.price
          : line.price,
    })),
  };
}
